'use client';
import {cn} from '@/lib/utils';
import {StrapiMenuItem} from '@/types/strapi';
import {useLocale, useTranslations} from 'next-intl';
import Link from 'next/link';
import {useEffect, useRef, useState} from 'react';
import {target} from '../helpers/utils';

export default function Menu185(Prop: {moduleData: any; highlight?: string}) {
  const menu: StrapiMenuItem[] = Prop.moduleData?.menu?.content || [];
  const lang = useLocale();
  const t = useTranslations();
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [isStick, setIsStick] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const btnRef = useRef<any>(null);
  const wrapperRef = useRef<any>(null);
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (btnRef.current && wrapperRef.current)
        setIsStick(
          currentY < lastScrollY &&
            wrapperRef.current.getBoundingClientRect().top <= 20
        );
      setLastScrollY(currentY);
    };
    window.addEventListener('scroll', handleScroll, {passive: true});
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    if (Prop.highlight) {
      setCurrentPath(Prop.highlight);
    } else {
      const path = window.location.pathname.replace(lang + '/', '');
      setCurrentPath(path);
      if (path.replace(lang, '').length <= 1) {
        setCurrentPath('/185-anniversary');
      }
    }
  }, []);

  return (
    <>
      <div
        className={cn(
          lang == 'en' ? 'ubuntu' : 'jhenghei',
          'xl:relative xl:left-1/2 xl:-translate-x-1/2 xl:min-w-[min(1280px,100cqw)]',
          'mt-[40px] xl:mt-[72px] mb-[37px] md:mb-[80px] xl:mb-[130px] w-fit md:px-4',
          'mx-auto xl:mx-0'
        )}
      >
        <h1
          className={cn(
            'abhaya-libre',
            'text-2xl md:text-[32px] md:leading-[45px] xl:text-5xl',
            'text-center mb-[25px] md:mb-[56px] xl:mb-[48px]',
            'font-[700]'
          )}
        >
          {t.rich('Title185', {
            span: (chunks: any) => (
              <span className="abhaya-libre">{chunks}</span>
            )
          })}
        </h1>
        <div ref={wrapperRef} className={cn('xl:hidden relative h-[50px]')}>
          <div
            className={cn(
              'pointer-events-none',
              !isStick && 'contents',
              isStick && 'fixed inset-0 z-20'
            )}
          >
            <button
              ref={btnRef}
              className={cn(
                'mx-auto flex justify-between gap-[16px] bg-white w-fit',
                'rounded-full px-5 py-2 h-[50px]',
                !isStick && 'absolute top-0 left-1/2 -translate-x-1/2 w-max',
                isStick && 'sticky top-[20px] left-0 right-0 z-20'
              )}
              style={{
                boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
                pointerEvents: 'all'
              }}
              onClick={() => setOpenMobileMenu(!openMobileMenu)}
            >
              <img
                className="w-[64px] h-[34px]"
                src={'/img/header/asw_185yrs_logo_' + lang + '.png'}
              />
              {menu
                .filter(
                  (e) =>
                    e.url.split('#')[0].split('?')[0] ==
                    currentPath.split('#')[0].split('?')[0]
                )
                .map((item: StrapiMenuItem) => (
                  <div
                    key={item.name}
                    className={cn(
                      'flex items-center gap-[4px] text-[#666666] text-[14px] font-[400]'
                    )}
                  >
                    {item.name}
                    <span className="material-symbols outlined xl:hidden text-[16px]">
                      keyboard_arrow_down
                    </span>
                  </div>
                ))}
            </button>
          </div>
        </div>
        <div
          className={cn(
            'pointer-events-none xl:contents ',
            !openMobileMenu && 'contents',
            openMobileMenu && 'fixed inset-0 z-50'
          )}
        >
          <nav
            className={cn(
              'mx-auto flex-col xl:flex xl:flex-row xl:justify-between',
              'xl:rounded-full xl:px-6 xl:py-4 xl:gap-3 bg-white ',
              'overflow-auto xl:overflow-visible items-center xl:w-fit',
              !openMobileMenu && 'hidden',
              openMobileMenu &&
                'flex sticky top-0 left-0 right-0 z-50 h-screen ',
              openMobileMenu &&
                'xl:h-auto xl:relative rounded-none p-0 gap-[32px]'
            )}
            style={{
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              pointerEvents: 'all'
            }}
            aria-label="Navigation Menu 185"
          >
            <div
              className={cn(
                'w-full pt-[60px] pb-[48px] mb-[12px] md:mb-[40px] xl:p-0 xl:m-0 xl:mr-3 xl:w-[80px]',
                'border-b-2 border-[#EAEAEA] xl:border-b-0',
                'sticky top-0 bg-white'
              )}
            >
              <img
                className="w-[140px] xl:w-[80px] mx-auto xl:mx-0"
                src={'/img/header/asw_185yrs_logo_' + lang + '.png'}
                alt="asw_185yrs_logo"
              />
              <span
                className={cn(
                  'xl:hidden material-symbols text-[24px] text-[#666666]',
                  'absolute top-[32px] right-[24px]'
                )}
                onClick={() => setOpenMobileMenu(false)}
              >
                close
              </span>
            </div>
            {menu.map((item: StrapiMenuItem) => (
              <div
                key={item.name}
                className={cn('leading-tight flex items-center')}
              >
                <Link
                  prefetch={false}
                  href={item.url}
                  target={target(item.url)}
                  locale={lang}
                >
                  <div
                    className={cn(
                      'flex items-center justify-between w-full text-left cursor-pointer text-center',
                      'xl:text-[18px] xl:leading-[24px] xl:text-[16px] md:leading-[24px] ',
                      'text-[20px] font-light xl:p-4',
                      item.url.split('#')[0].split('?')[0] ==
                        currentPath.split('#')[0].split('?')[0]
                        ? 'xl:bg-[#e22319] xl:text-white xl:hover:text-white xl:rounded-full'
                        : 'xl:text-[#666666] xl:hover:text-[#e22319]'
                    )}
                  >
                    {item.name}
                  </div>
                </Link>
              </div>
            ))}
            <div className="h-[120px] xl:hidden"></div>
          </nav>
        </div>
      </div>
      {!Prop.highlight &&
        menu
          .filter(
            (e) =>
              e.url.split('#')[0].split('?')[0] ==
              currentPath.split('#')[0].split('?')[0]
          )
          .map((item: StrapiMenuItem) => (
            <h2
              key={item.name}
              className={cn(
                'abhaya-libre',
                'text-center text-[20px] leading-[45px] font-[400]',
                'md:text-[28px] md:leading-[32px] xl:text-[40px] xl:leading-[45px]',
                'mb-[20px] md:mb-[60px]'
              )}
            >
              {item.name}
            </h2>
          ))}
    </>
  );
}
